
import { defineComponent } from "vue";
import CheckMark from "@/components/icon/CheckMark.vue";
import BaseButton from "@/components/BaseButton.vue";

export default defineComponent({
  name: "PurchaseSuccess",
  components: { CheckMark, BaseButton },
});
